import React from "react";
import { Link } from "react-router-dom";
import "./CSS/CartHero.css";
import bannerImg from "./IMAGES/Rectangle 1 (2).png";

const CartHero = () => {
  return (
    <div className="conatct-banner">
      <img src={bannerImg} alt="conatct-banner" />

      <div className="conatct-overlay">
        <h1>Cart</h1>
        <p>
          <Link to="/">Home</Link> <span>›</span>{" "}
          <span className="conatct-active">Cart</span>
        </p>
      </div>
    </div>
  );
};

export default CartHero;
